import { combineReducers } from 'redux';
import { reducer as reduxAsyncConnect } from 'redux-connect';

import cookies from 'common/reducers/cookies';
import serverResponse from 'common/reducers/serverResponse';
import viewer from 'common/reducers/viewer';

export default combineReducers({
  cookies,
  reduxAsyncConnect,
  serverResponse,
  viewer,
});
